/**
 * A = control group
 *
 * B = test group
 */
export type CueGroup = 'a' | 'b';

/**
 * A = control group
 *
 * B = test group
 */
export const generateCueGroup = (userId: string): CueGroup | undefined => {
  if (typeof userId !== 'string') {
    return undefined;
  }

  const firstCharacter = userId.charAt(0);

  if (['0', '1', '2', '3', '4', '5', '6', '7'].includes(firstCharacter)) {
    return 'a';
  }

  if (['8', '9', 'a', 'b', 'c', 'd', 'e', 'f'].includes(firstCharacter)) {
    return 'b';
  }

  return undefined;
};
